import { Page } from "@roc/feature-app-core";
import { Route } from "react-router";
import { ClosingCoordinatorDashboard } from "../components/closingCoordinatorDashboard";
import { ClosingTodayGrid } from "../components/closingTodayGrid";
import { ClosingTomorrowGrid } from "../components/closingTomorrowGrid";
import { FutureClosingsGrid } from "../components/futureClosingsGrid";

export const getClosingCoordinatorInternalRoutesConfig = (
  basePath: string,
  baseUrl: string,
) => {
  return {
    closingCoordinatorDashboard: {
      path: `${basePath}/closing-coordinator-dashboard`,
      url: `${baseUrl}/closing-coordinator-dashboard`,
      documentTitle: 'closing-coordinator-dashboard',
    },
    closingTodayEmbed: {
      path: `${basePath}/closing-coordinator-dashboard/closing-today`,
      url: `${baseUrl}/closing-coordinator-dashboard/closing-today`,
      documentTitle: 'closing-coordinator-today',
    },
    closingTomorrowEmbed: {
      path: `${basePath}/closing-coordinator-dashboard/closing-tomorrow`,
      url: `${baseUrl}/closing-coordinator-dashboard/closing-tomorrow`,
      documentTitle: 'closing-coordinator-tomorrow',
    },
    futureClosingEmbed: {
      path: `${basePath}/closing-coordinator-dashboard/future-closings`,
      url: `${baseUrl}/closing-coordinator-dashboard/future-closings`,
      documentTitle: 'closing-coordinator-future',
    },
  }
}

export const getClosingCoordinatorInternalRoutes = (
  basePath: string,
  baseUrl: string,
) => {
  const config = getClosingCoordinatorInternalRoutesConfig(basePath, baseUrl);

  return {
    closingCoordinatorDashboard: (
      <Route exact path={config.closingCoordinatorDashboard.path}>
        <Page routeDefinition={config.closingCoordinatorDashboard}>
          <ClosingCoordinatorDashboard/>
        </Page>
      </Route>
    ),
    closingTodayEmbed: (
      <Route exact path={config.closingTodayEmbed.path}>
        <Page routeDefinition={config.closingTodayEmbed}>
          <ClosingTodayGrid/>
        </Page>
      </Route>
    ),
    closingTomorrowEmbed: (
      <Route exact path={config.closingTomorrowEmbed.path}>
        <Page routeDefinition={config.closingTomorrowEmbed}>
          <ClosingTomorrowGrid/>
        </Page>
      </Route>
    ),
    futureClosingEmbed: (
      <Route exact path={config.futureClosingEmbed.path}>
        <Page routeDefinition={config.futureClosingEmbed}>
          <FutureClosingsGrid/>
        </Page>
      </Route>
    ),
  }
}
